import React, { useCallback, useState, useEffect } from 'react'
import { UserMenuActionItems } from './UserMenuActionItems';
import { useSelector } from 'react-redux';

export const UserMenuAction = ({ show: showProp, onToggle, onClose }) => {
    const [internalShow, setInternalShow] = useState(false);
    const isControlled = typeof showProp === 'boolean';
    const show = isControlled ? showProp : internalShow;
    const { available = true, photoUrl = '', name = '' } = useSelector( state => state.auth)

    const closeMenu = useCallback(() => {
        if (isControlled) {
            onClose?.();
            return;
        }

        setInternalShow(false);
    }, [isControlled, onClose]);

    const toggleMenu = () => {
        if (isControlled) {
            onToggle?.();
            return;
        }

        setInternalShow((prev) => !prev);
    };

    const getInitials = (text = '') => {
        const safeText = String(text || '').trim();
        if (!safeText) {
            return 'US';
        }

        const words = safeText.split(/\s+/).filter(Boolean);
        if (words.length === 1) {
            return words[0].slice(0, 2).toUpperCase();
        }

        return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase();
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.nxl-user-dropdown') && !event.target.closest('.nxl-h-item')) {
                closeMenu();
            }
        };

        if (show) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [show, closeMenu]);

    return (
        <div className="dropdown nxl-h-item">
            <button type="button" className="bg-transparent border-0 p-0" data-bs-toggle="dropdown" data-bs-auto-close="outside" onClick={toggleMenu}>
                <div className="user-menu-avatar-wrap">
                    {photoUrl ? (
                        <img src={photoUrl} alt="user-image" className="img-fluid user-avtar" />
                    ) : (
                        <span className="user-menu-avatar-fallback">{getInitials(name)}</span>
                    )}
                    <span
                        className={`user-menu-avatar-status-dot ${available ? 'is-available' : 'is-unavailable'}`}
                        aria-hidden="true"
                    />
                </div>
            </button>
            <UserMenuActionItems show={show} onItemClick={closeMenu} />
        </div>
    )
}
